export const ownersQuery = (address) => `
  {
    owner (id: "${address}") {
      id
      lifeforms {
        id
      }
    }
  }
`;